/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import { useErrorsStore } from '.';

function useErrors () {
    const errors = useErrorsStore();
    const [error, setError] = useState({});

    useEffect(() => {
        // console.log(' useErrors Store ', errors);
        if(!isEmpty(errors.error)) {
            setError({
                ...errors.error,
                refId: errors.env.traceId,
            });
        }
    }, [errors.observed.error]);
 
    return {
        error,
    };
}

export default useErrors;